import { handleActions } from 'redux-actions';
import * as apiActions from '../actions'; 


const defaultState = {
    error: '',
    execuationAutomation: [],
    buildJenkinsJob:[],
    buildJenkinsJobStatus:[],
    redirectUrl:{},
    featureNames:[],
    featureSteps:[],
    allTest:{}

  };

  export const automationExecution  = handleActions(
    {
      [apiActions.jenkinJobEngrSuccess]: (state, action) => {
          return {
            ...state,
            execuationAutomation: []
          };
        },
      [apiActions.getFeatureNameSuccess]: (state, action) => {
          return {
            ...state,
            featureNames: []
          };
        },
      [apiActions.getFeatureStepsSuccess]: (state, action) => {
          return {
            ...state,
            featureSteps:[ ...state.featureSteps, action.payload]
          };
        },
      [apiActions.allTestCasesSuccess]: (state, action) => {
          return {
            ...state,
            allTest: []
          };
        },
      [apiActions.redirectUrlSuccess]: (state, action) => {
          return {
            ...state,
            redirectUrl: []
          };
        },
      [apiActions.redirectUrlClear]: (state, action) => {
          return {
            ...state,
            redirectUrl: action.payload
          };
        },
      [apiActions.jenkinJobEngrUpdate]: (state, action) => {
          return {
            ...state,
             execuationAutomation:state.execuationAutomation.map(item=>item.jobId===action.payload.jobId?{...item,...{'active':(action.payload.jobStatus==='Completed')?false:true, 'SmokeStatus': action.payload.jobStatus, 'remainingProgressTime': action.payload.remainingProgressTime,'actualProgressTime':action.payload.actualProgressTime,'bufferTimeFlag': action.payload.bufferTimeFlag,'actualTimeSpentInMin':action.payload.actualTimeSpentInMin,'expectedTimeInMin':action.payload.expectedTimeInMin}}:item)
            
          }
        },
        [apiActions.jenkinJobEngrForceUpdate]: (state, action) => {
          return {
            ...state,
             execuationAutomation:state.execuationAutomation.map(
              item=>{
                let temp = Object.assign({}, item);
                let data=action.payload[0];
                if (temp.jobId === data.jobId) {
                    temp.SmokeStatus = data.jobStatus;
                }
                return temp;
              }

             )
          }
        },
        [apiActions.jenkinPieChartUpdate]: (state, action) => {
          return {
            ...state,
             execuationAutomation:state.execuationAutomation.map(item=>item.jobId===action.payload.jobId?{...item,...{'pieChartData': action.payload.pieChartData, 'pieChartStatus': action.payload.pieChartStatus}}:item)
            
          }
        },
      
      [apiActions.jenkinJobEngrAddRow]: (state, action) => {
          return {
            ...state,
            execuationAutomation: [...state.execuationAutomation, action.payload]
          }
        },
    },
    defaultState
  );

